import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Clock, MessageSquare } from "lucide-react";
import Logo from "./Logo";
import { NAV, ORG } from "../mock";

export default function Footer() {
  return (
    <footer className="bg-brand-navy text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <Logo size={44} light />
              <div className="font-serif font-bold text-white text-lg">ISEC</div>
            </div>
            <p className="text-sm leading-relaxed text-slate-400">
              The International Securities &amp; Exchange Commission of Sierra Leone
              regulates and develops the nation&apos;s capital markets.
            </p>
            <Link
              to="/contact"
              className="mt-5 inline-flex items-center gap-2 bg-brand-green text-white text-sm font-semibold px-4 py-2.5 rounded-md hover:bg-[#0f6339] transition-colors"
            >
              <MessageSquare size={16} /> Contact Us
            </Link>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wide">
              Quick Links
            </h4>
            <ul className="space-y-2.5 text-sm">
              {NAV.map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className="hover:text-white transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wide">
              For Investors
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/regulated-entities" className="hover:text-white transition-colors">Verify a licensed firm</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">File a complaint</Link></li>
              <li><Link to="/news" className="hover:text-white transition-colors">Investor alerts</Link></li>
              <li><Link to="/regulation" className="hover:text-white transition-colors">Laws &amp; rules</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wide">
              Contact
            </h4>
            <ul className="space-y-3 text-sm">
              <li className="flex gap-2.5"><MapPin size={16} className="shrink-0 mt-0.5 text-brand-green" /><span>{ORG.address}</span></li>
              <li className="flex gap-2.5"><Phone size={16} className="shrink-0 mt-0.5 text-brand-green" /><span>{ORG.phone}</span></li>
              <li className="flex gap-2.5"><Clock size={16} className="shrink-0 mt-0.5 text-brand-green" /><span>{ORG.hours}</span></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-400">
          <p>© {new Date().getFullYear()} {ORG.name}. All rights reserved.</p>
          <p className="flex items-center gap-4">
            <Link to="/policies" className="hover:text-white">Privacy Policy</Link>
            <Link to="/policies" className="hover:text-white">Terms of Use</Link>
            <Link to="/policies" className="hover:text-white">Accessibility</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
